import './address-container.scss';

import { Box, Stack } from '@mui/material';
import {
  CreateBrokerageField,
  getCreateBrokerageFieldProps,
} from '@converge/data';
import {
  NewCountryFormSelectField,
  NewFormTextField,
  NewRegionFormSelectField,
} from '../../presentation';

export const AddressContainer = ({ isReadOnly }: { isReadOnly?: boolean }) => {
  return (
    <>
      <Stack className="subsidiary-row">
        <Box className="address1">
          <NewFormTextField
            {...getCreateBrokerageFieldProps(CreateBrokerageField.Street1)}
            required
            autoComplete={false}
            placeholder="1234 Main St"
            dataTestId="billing-street1-input"
            disabled={isReadOnly}
          />
        </Box>
        <Box className="address2">
          <NewFormTextField
            {...getCreateBrokerageFieldProps(CreateBrokerageField.Street2)}
            autoComplete={false}
            placeholder="Suite 123"
            dataTestId="billing-street2-input"
            disabled={isReadOnly}
          />
        </Box>
        <Box className="city">
          <NewFormTextField
            {...getCreateBrokerageFieldProps(CreateBrokerageField.City)}
            autoComplete={false}
            placeholder="City"
            required
            dataTestId="billing-city-input"
            disabled={isReadOnly}
          />
        </Box>
      </Stack>
      <Stack className="subsidiary-row">
        <Box className="state">
          <NewRegionFormSelectField
            {...getCreateBrokerageFieldProps(CreateBrokerageField.RegionUuid)}
            required
            placeholder="Select State"
            dataTestId="billing-state-dropdown"
            disabled={isReadOnly}
          />
        </Box>
        <Box className="zipCode">
          <NewFormTextField
            {...getCreateBrokerageFieldProps(CreateBrokerageField.PostalCode)}
            autoComplete={false}
            placeholder="Enter Postal or ZIP Code"
            required
            dataTestId="billing-postal-code-input"
            disabled={isReadOnly}
          />
        </Box>
        <Box className="country">
          <NewCountryFormSelectField
            {...getCreateBrokerageFieldProps(CreateBrokerageField.CountryUuid)}
            required
            disabled={isReadOnly}
            dataTestId="billing-country-dropdown"
          />
        </Box>
      </Stack>
    </>
  );
};
